import { useMediator } from '../useMediator';

export const PartPointsData = () => {
  let pointList = {};

  const [setMediator, destroyMediator] = useMediator();

  const addPoint = (id) => {
    if (!pointList[id]) {
      pointList[id] = {};
    }
  };
  const getList = () => pointList;

  const updatePointData = (id, arr = [], scope) => {
    if (arr.length > 0) {
      addPoint(id);
      pointList[id][scope] = arr;
    } else if (pointList[id]) {
      if (pointList[id][scope]) delete pointList[id][scope];
      if (
        typeof pointList[id] === 'object' &&
        Object.keys(pointList[id]).length === 0
      )
        delete pointList[id];
    }
  };

  const removePointById = (id) => delete pointList[id];

  const clear = () => {
    pointList = {};
  };
  const destroy = () => {
    clear();
    destroyMediator();
  };

  return Object.freeze({
    setMediator,
    clear,
    destroy,
    getList,
    updatePointData,
    removePointById,
  });
};
